import {MD_WIDTH} from "@main/helpers/const";

const SHIFT_COORD_LG_FOR_MOBILE = 0.0012;
const SHIFT_COORD_LT_FOR_TABLET = 0.0068;
const ZOOM_MAP_DEFAULT = 10;
/*global ymaps*/

/**
 * Компонент карты с элементами масштабирования.
 */
class Map {
    iconSize = window.innerWidth < MD_WIDTH ? [40, 40] : [62, 62];
    defaultOptionPlacemark = {
        iconLayout: "default#image",
        iconImageHref: "/images/svg/pin.svg",
        iconImageSize: this.iconSize,
        iconImageOffset: [-10, -50],
    };
    /**
     * Создает карту с указанными настройками.
     *
     * @param {HTMLElement} mapNode Элемент "карта".
     */
    constructor(mapNode) {
        this.map = mapNode;
        this.lg = mapNode.dataset.lg;
        this.lt = mapNode.dataset.lt;
        this.zoom = mapNode.dataset.zoom || ZOOM_MAP_DEFAULT;
        if (mapNode.dataset.icon) {
            this.defaultOptionPlacemark.iconImageHref = mapNode.dataset.icon
        }
        this.bindMap();
    }

    /**
     * Указываем параметры для карты (метку на карте, зум и другое).
     *
     * @returns {void}
     */
    bindMap() {
        ymaps.ready(() => {
            const map = new ymaps.Map(
                "map",
                {
                    center: this.getCoordsCenterMap(),
                    zoom: this.zoom,
                    controls: [],
                },
                {suppressMapOpenBlock: true}
            );

            /** Настройка метки: позиционирование, стилизация иконки */
            const placemark = new ymaps.Placemark(
                [this.lg, this.lt],
                {},
                this.defaultOptionPlacemark
            );

            map.geoObjects.add(placemark);
        });
    }

    /**
     * Получить координаты центра карты.
     *
     * @returns {Array} Массив координат.
     */
    getCoordsCenterMap() {
        const coordLgForMobile = String(parseFloat(this.lg) - SHIFT_COORD_LG_FOR_MOBILE);
        const coordLtForTablet = String(parseFloat(this.lt) - SHIFT_COORD_LT_FOR_TABLET);

        if (window.innerWidth < MD_WIDTH) {
            return [coordLgForMobile, this.lt];
        } else {
            return [this.lg, coordLtForTablet];
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const mapNode = document.querySelector(".js-mch-map");
    if (mapNode) {
        new Map(mapNode);
    }
});
